import React from 'react';

import { i18n } from '@lt/localization';
import MultichoiceFilterGroup from '../../../../../../../components/Filters/components/MultichoiceFilterGroup';
import type { ExtendedFilterInfo, FilterProps } from '../types';

const FilterPaymentBenefits = (props: FilterProps): JSX.Element => (
  <MultichoiceFilterGroup {...props} Filter={FilterPaymentBenefits} />
);

FilterPaymentBenefits.getFilterVisibleName = (
  filterOptionData: ExtendedFilterInfo,
) => filterOptionData.name;

FilterPaymentBenefits.filterName = 'payment_benefits';
FilterPaymentBenefits.filterLabel = i18n.t('filters.payment.title');

export default FilterPaymentBenefits;
